import { HxAccount, HxMailAccountData, SessionId } from '@outlook/hxcore_web';
import { runInHxSession } from './runInHxSession';
import { waitForHxObjectChange } from './waitForHxObjectChange';
import { handleHxObjectLoadResult } from 'hx-object-load-helpers';

const INITIAL_FOLDER_SYNC_TIMEOUT = 10000;

export function waitForInitialFolderSync(hxAccount: HxAccount): Promise<HxMailAccountData> {
    return runInHxSession(async (sessionId: SessionId) => {
        const hxMailAccountData = handleHxObjectLoadResult(await hxAccount.getMail(sessionId));
        return waitForHxObjectChange(
            hxMailAccountData,
            (hxMailAccountData: HxMailAccountData) => !hxMailAccountData.sentItemsViewId.isNil(),
            INITIAL_FOLDER_SYNC_TIMEOUT
        );
    });
}
